export type StartSubscriptionOptions = {
  invokeIfRunning?: boolean;
};
